export default __webpack_public_path__ + "static/media/hood.aa4d2078.png";